export const CommonRels = {
    GetCountryCodes: 'getPhoneCountryCodes',
    GetCountries: 'getCountries',
    BoomerangExternalUrl: 'boomerangExternalUrl',
    IdentityExternalUrl: 'identityExternalUrl',
    LocalizationAdminExternalUrl: 'localizationAdminExternalUrl'
};
